// StatisticaQueueKg.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { apiActions } from './actions';
import { getArrPeriods, processQueueData } from './helpers/queueHelpers';
import QueueFilters from './components/QueueFilters';
import QueueTable from './components/QueueTable';
import './StatisticaQueue.css';

const StatisticaQueueKg = () => {
  const periods = getArrPeriods();
  
  const [selDist, setSelDist] = useState('all');
  const [period, setPeriod] = useState(periods[0]);
  const [queueData, setQueueData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getInfoAboutQueue = useCallback(async () => {
    setLoading(true);
    
    const params = [
      `district=${selDist}`,
      `period=${period}`
    ];

    try {
      const res = await apiActions.getQueueHistory(params);
      
      if (res.data) {
        const processedData = processQueueData(res.data);
        setQueueData(processedData);
      } else {
        setQueueData([]);
      }
    } catch (error) {
      console.error('Error fetching queue history:', error);
      setQueueData([]);
    } finally {
      setLoading(false);
    }
  }, [selDist, period]);

  const handleDistrictChange = useCallback((e) => {
    setSelDist(e.target.value);
  }, []);

  const handlePeriodChange = useCallback((e) => {
    setPeriod(e.target.value);
  }, []);

  useEffect(() => {
    getInfoAboutQueue();
  }, []);

  return (
    <div className="queue-container">
      <QueueFilters
        selDist={selDist}
        period={period}
        periods={periods}
        onDistrictChange={handleDistrictChange}
        onPeriodChange={handlePeriodChange}
        onShowData={getInfoAboutQueue}
      />

      <QueueTable
        data={queueData}
        loading={loading}
      />
    </div>
  );
};

export default StatisticaQueueKg;